<template>
  <div id="app">
    <div class="button-container">
      <button @click="open()" type="button" class="btn btn-lg btn-primary"><i class="bi bi-plus"></i> {{ title }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddButton',
  props: {
    title: String
  },

  methods: {
    open() {
      this.$emit('open')
    }
  }
}

</script>

<style scoped>
#app {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}

.button-container {
  margin-left: auto;

}

.btn {
  border: none;
  background-color: var(--blue-5);
  width: calc(50vw);
  min-width: 150px;
  font-size: calc( 12px * var(--font-scale));
}

@media (max-width: 1600px) {
  .btn {
    width: calc(5vw);
  }
}

@media (max-width: 1366px) {
  .btn {
    width: calc(10vw);
  }
}

@media (min-width: 1000px) {
  .btn {
    width: calc(30vw);
  }
}
</style>